var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgexport151(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.657,
    height: 20,
    viewBox: "0 0 16.657 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(51,51,51,0.78);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.653,2.986a.833.833,0,0,0-.82.844v7.722a1.664,1.664,0,1,0,1.666,0V3.831a.833.833,0,0,0-.846-.844Zm6.663,0a.833.833,0,0,0-.82.844V6.554a1.667,1.667,0,1,0,1.666,0V3.831a.833.833,0,0,0-.846-.844Zm6.663,0a.833.833,0,0,0-.82.844V14.884a1.664,1.664,0,1,0,1.666,0V3.831a.833.833,0,0,0-.846-.844ZM12.5,11.209V22.153a.833.833,0,1,0,1.666,0V11.209a3.02,3.02,0,0,1-1.666,0Zm-6.663,5v5.947a.833.833,0,1,0,1.666,0V16.206a3.312,3.312,0,0,1-.833.117A3.312,3.312,0,0,1,5.833,16.206Zm13.326,3.331v2.616a.833.833,0,1,0,1.666,0V19.538a3.02,3.02,0,0,1-1.666,0Z",
    transform: "translate(-5 -2.986)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport151);
export default __webpack_public_path__ + "static/media/svgexport-15-1.e80919631c28b0bdf82a508d8d6934eb.svg";
export { ForwardRef as ReactComponent };